import View from "backdraft-app/src/view";
import ReactDOM from 'react-dom';

export default class ReactView extends View {
  constructor(component) {
    super();
    this.component = component;
  }

  render() {
    ReactDOM.render(this.component, this.el);
    return this;
  }

  close() {
    ReactDOM.unmountComponentAtNode(this.el);
    super.close();
  }
}
